import React from 'react';
import cn from 'classnames';
import type { TransferInfo } from '@lt/api/dist/methods/packages/types';
import { i18n } from '@lt/localization';

import CurrencyFormat from 'src/components/CurrencyFormat';
import type { OrderPriceInfo } from '@lt/api/dist/methods/orders/types';
import PriceDetails from '../PriceDetails';
import PriceDetailsItem from '../PriceDetailsItem';

const baseCls = 'checkout-summary-prices';

export interface PriceInfoProps {
  data?: OrderPriceInfo[];
  transferInfo?: TransferInfo | null;
}

// Сделала здесь дополнительную PriceDetailItem для отображения цены трансфера на Мальдивах
// Не знаю, как лучше, что так костыль, что через priceInfo тоже

const PriceInfo = ({ data, transferInfo }: PriceInfoProps) => (
  <div>
    <PriceDetails className={baseCls}>
      {data &&
        data.map(({ title, amount, price_id }) => {
          const isDiscount = amount < 0;
          const prefix =
            price_id === 'package_net_price'
              ? ''
              : (isDiscount && '- ') || '+ ';
          return (
            <PriceDetailsItem
              key={price_id}
              className={cn({ [`${baseCls}__item--discount`]: isDiscount })}
              label={title}
            >
              <div>
                <CurrencyFormat
                  className={`${baseCls}__value`}
                  value={
                    transferInfo
                      ? Math.abs(amount - transferInfo.price)
                      : Math.abs(amount)
                  }
                  prefix={prefix}
                />
              </div>
            </PriceDetailsItem>
          );
        })}

      {transferInfo ? (
        <PriceDetailsItem
          label={i18n.t('checkout.packageInfo.transferBanner.transfer')}
        >
          <div>
            {transferInfo.price ? (
              <CurrencyFormat
                className={`${baseCls}__value`}
                value={Math.abs(transferInfo.price)}
                prefix="+ "
              />
            ) : (
              i18n.t('checkout.packageInfo.transferBanner.included')
            )}
          </div>
        </PriceDetailsItem>
      ) : null}
    </PriceDetails>
  </div>
);

export default PriceInfo;
